<p-table
    [value]="paginationResult.entities"
    [lazy]="true"
    (onLazyLoad)="loadData($event)"
    [rows]="paginationRequest.pageSize"
    [totalRecords]="paginationResult.filteredEntities"
    [rowsPerPageOptions]="[10, 20, 50]"
    [paginator]="true"
    [loading]="loading"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
    class="custom-table"
    styleClass="p-datatable-striped"
>
    <!-- CAPTION -->
    <ng-template pTemplate="caption">
        <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            {{ 'tableManagement.driverAssignment.futureDateWarningHeader' | translate }}
        </div>
    </ng-template>

    <!-- HEADER -->
    <ng-template pTemplate="header">
        <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            <!-- DRIVER -->
            <th pSortableColumn="driver.employee.user.surname1">
                <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'drivers.header' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="driver.employee.user.surname1"></p-sortIcon>
                    </div>
                </div>
            </th>

            <!-- EMPRESA -->
            <th pSortableColumn="billingAccount.name">
                <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.companies.company' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="billingAccount.name"></p-sortIcon>
                        <p-columnFilter field="billingAccount" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="companiesList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}" (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                                    <ng-template let-option pTemplate="item">
                                        <div>
                                            <span class="ml-1">({{option.code}}) {{option.name}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </div>
            </th>

            <!-- CECO -->
            <th pSortableColumn="ceco.description">
                <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'drivers.table.ceco' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="ceco.description"></p-sortIcon>
                        <p-columnFilter field="ceco" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="cecoList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}" (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                                    <ng-template let-option pTemplate="item">
                                        <div>
                                            <span class="ml-1">({{option.code}}) {{option.description}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </div>
            </th>

            <!-- DIVISION -->
            <th pSortableColumn="division.name">
                <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.delegations.delegation' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="division.name"></p-sortIcon>
                    </div>
                </div>
            </th>

            <!-- SUBDIVISION -->
            <th pSortableColumn="subDivision.name">
                <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.subdelegations.subdelegation' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="subDivision.name"></p-sortIcon>
                    </div>
                </div>
            </th>

            <!-- START DATE -->
            <th pSortableColumn="startDate">
                <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.cardLists.assignDateShort' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="startDate"></p-sortIcon>
                    </div>
                </div>
            </th>

            <!-- KMS -->
            <th>
                <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                    Kms
                </div>
            </th>

            <!-- DELETE -->
            <th class="button-column"></th>
        </tr>
    </ng-template>

    <!-- BODY -->
    <ng-template pTemplate="body" let-p>
        <tr class="p-selectable-row custom-rows" (dblclick)="editDialog(p)" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            <td>{{ p.driver?.employee?.user?.surname1 }} {{ p.driver?.employee?.user?.surname2 }}, {{ p.driver?.employee?.user?.name }}</td>
            @if (p.billingAccount) {
                <td>({{ p.billingAccount.code }}) {{ p.billingAccount.name }}</td>
            } @else {
                <td>N/A</td>
            }
            @if (p.ceco) {
                <td>({{ p.ceco.code }}) {{ p.ceco.description }}</td>
            } @else {
                <td>N/A</td>
            }
            @if (p.division) {
                <td>({{ p.division.code }}) {{ p.division.name }}</td>
            } @else {
                <td>N/A</td>
            }
            @if (p.subDivision) {
                <td>({{ p.subDivision.code }}) {{ p.subDivision.name }}</td>
            } @else {
                <td>N/A</td>
            }
            <td>{{ p.startDate | date: 'dd/MM/yyyy' }}</td>
            <td>{{ p.kms }}</td>
            <td>
                @if (canDelete) {
                    <div>
                        <button type="button" class="btn custom-table-remove-button" (click)="onDeleteAssignment(p)">
                            <svg-icon
                                src="assets/icons/trash.svg"
                                class="d-flex flex-wrap custom-table-remove-button-icon"
                                [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
                            ></svg-icon>
                        </button>
                    </div>
                }
            </td>
        </tr>
    </ng-template>

    <!-- EMPTY MESSAGE -->
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8" class="p-0">
                <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message">
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
<app-pending-driver-assignments-form></app-pending-driver-assignments-form>

<p-confirmDialog
    [header]="'confirm.critic' | translate"
    [message]="'control-panel.delete-dialog.message' | translate"
    [acceptLabel]="'general.yes' | translate"
    [rejectLabel]="'general.no' | translate"
    acceptButtonStyleClass="custom-button"
    rejectButtonStyleClass="custom-button"
    class="custom-dialog"
    icon="pi pi-exclamation-triangle"
    key="pending-driver-assignments-list"
    appendTo="body"
></p-confirmDialog>
